import {
  CONFIRMED_GET_BRANCHES,
  CONFIRMED_CREATE_BRANCH_ACTION,
  CONFIRMED_DELETE_BRANCH_ACTION,
  CONFIRMED_EDIT_BRANCH_ACTION,
} from "../actions/BranchTypes";

const initialState = {
  branches: [],
  num_rows: 0,
};

export default function BranchReducer(state = initialState, action) {
  if (action.type === CONFIRMED_GET_BRANCHES) {
    return {
      ...state,
      // branches: action.payload,
      branches: action.payload.branches || action.payload,
      num_rows: action.payload.num_rows || 0,
    };
  }

  if (action.type === CONFIRMED_CREATE_BRANCH_ACTION) {
    const branches = [...state.branches];
    branches.push(action.payload);

    return {
      ...state,
      branches,
    };
  }

  if (action.type === CONFIRMED_DELETE_BRANCH_ACTION) {
    const branches = state.branches.filter(
      (branch) => branch.branch_id !== action.payload.branch_id
    );

    return {
      ...state,
      branches,
    };
  }

  if (action.type === CONFIRMED_EDIT_BRANCH_ACTION) {
    const branches = [...state.branches];
    const index = branches.findIndex(
      (branch) => branch.branch_id === action.payload.branch_id
    );

    if (index !== -1) {
      branches[index] = action.payload;
    }

    return {
      ...state,
      branches,
    };
  }

  return state;
}
